import React from "react"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import { connect } from "react-redux"
import { translate } from "react-i18next"

import Typograph from "components/Typograph"
import CustomerGreetingsSkeleton from "components/Skeleton/CustomerGreetings"

import { capitalizeString } from "services/utils/capitalize"

const CustomerGreetings = ({ t, name, isLoading }) => {
  const nameToUse = name || ""

  if (isLoading) {
    return <CustomerGreetingsSkeleton />
  }

  return (
    <Typograph
      htmlTag="span"
      preset="span"
      color="deep_sea_green"
      weight="regular"
    >
      {t("MSG_0462", { name: capitalizeString(nameToUse) })}
    </Typograph>
  )
}

CustomerGreetings.propTypes = {
  name: PropTypes.string,
  t: PropTypes.func,
  isLoading: PropTypes.bool
}

const mapStateToProps = ({ customer }) => {
  return {
    isLoading: customer.loading,
    name: !customer.loading ? customer.data.name : ""
  }
}

const enhance = compose(translate(), connect(mapStateToProps, null))

export default enhance(CustomerGreetings)



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Main/CustomerGreetings.js